import React, { useState } from 'react'
import PropTypes from 'prop-types'
import TextArea from '../../inputs/text-area'
import SelectInput from '../../inputs/select-input'
import MultiSelect from '../../inputs/multi-select'

const TeamInfo = ({initialName, balance, league, register, control, setValue, getValues, onDelete}) => {
  const [fileName, setFileName] = useState('')
  const [editName, setEditName] = useState(false)
  const teamPrice = parseFloat(league.team_price).toFixed(2)
  const teamBalance = parseFloat(balance).toFixed(2)
  const currencyName = league.currency == 'usd' ? '' : ` (${league.currency.toUpperCase()})`
  const [photoUrl, name, captainName, locationName] = getValues(
    ['photo_url', 'name', 'captain_name', 'location_name']
  )
  const colorOptions = [ 
    { value: 'Red', label: 'Red', className: 'color-value red' },
    { value: 'Blue', label: 'Blue', className: 'color-value blue' },
    { value: 'Green', label: 'Green', className: 'color-value green' },
    { value: 'Yellow', label: 'Yellow', className: 'color-value dark-color yellow' },
    { value: 'Purple', label: 'Purple', className: 'color-value purple' },
    { value: 'Pink', label: 'Pink', className: 'color-value pink' },
    { value: 'Orange', label: 'Orange', className: 'color-value orange' },
    { value: 'Brown', label: 'Brown', className: 'color-value brown' },
    { value: 'Black', label: 'Black', className: 'color-value black' },
    { value: 'White', label: 'White', className: 'color-value dark-color white' },
  ]
  const imageUrl = () => {
    if (!photoUrl) return '/images/leagues/team.png'

    if (photoUrl && photoUrl.includes('data:')) return photoUrl
    else return photoUrl + '?' + Math.random()
  }

  const loadFile = (file) => {
    if(file.size > 10000000) return window.alert('File size limit is 10MB')
    if (!['image/jpeg', 'image/png'].includes(file.type)) return window.alert(' Only JPG and PNG files are allowed')

    const fr = new FileReader()
    fr.onloadend = function() { 
      setValue('photo_url', fr.result)
      setFileName(file.name)
    }
    fr.readAsDataURL(file)
  }

  const fileLoaded = (files) => {
    if (files && files[0]) loadFile(files[0])
  }

  const clickDelete = (e) => {
    e.stopPropagation()
    if (window.confirm('Are you sure you want to delete this team?')) onDelete()
  }

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      setEditName(false)
      setName(e.target.value)
    }
  }

  const onBlur = (e) => {
    setEditName(false)
    setName(e.target.value)
  }

  const setName = (value) => {
    if (!value.trim()) setValue('name', initialName)
  }

  return <div className='team-info-section'>
    <div className='team-info-title'>
      <div className='team-info-photo'>
        <input 
          type='file'
          accept='image/png,image/jpeg'
          id='team-info-photo-input'
          onChange={(e) => fileLoaded(e.target.files)}
        />
        <label id='team-info-photo-label' htmlFor='team-info-photo-input'>
          <img alt='Icon' src={imageUrl()} />
        </label>
      </div>
      { !editName && <div className='team-info-name' onClick={() => setEditName(true)}>{name}</div> }
      { editName && 
        <input 
          {...register('name')}
          className='team-edit-name'
          autoFocus={true}
          onChange={(e) => setValue('name', e.target.value)}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
        />
      }
      <div className='team-info-captain'>
        <img src='/images/leagues/captain.png' />
        {`Captain: ${captainName}`}
      </div>
      <div className='team-info-games'>⚽️ Games: 0</div>
    </div>
    <div className='team-info-prices'>
      <div className='panel panel-warning'>
        <div className='panel-heading'>{`Current Balance${currencyName}`}</div>
        <div className='panel-body cost-edit-form-wrapper'>
          <span className='total-reservation-cost'>{`$ ${teamBalance}`}</span>&nbsp;
        </div>
      </div>
      <div className='panel panel-info'>
        <div className='panel-heading'>{`Total Price${currencyName}`}</div>
        <div className='panel-body cost-edit-form-wrapper'>
          <span className='total-reservation-cost'>{`$ ${teamPrice}`}</span>&nbsp;
        </div>
      </div>
    </div>
    <TextArea
      {...register('about')}
      label='About the team'
      rows='4'
      onChange={(e) => setValue('about', e.target.value)}
    />
    <TextArea
      {...register('notes')}
      label='Notes'
      rows='5'
      onChange={(e) => setValue('notes', e.target.value)}
    />
    <SelectInput 
      disabled
      options={[locationName]}
      value={locationName}
      label='Location'
    />
    <MultiSelect 
      name='color'
      label='Color (up to 3 colors)'
      options={colorOptions}
      limit={3}
      control={control}
      onChange={(values) => setValue('color', values)}
    />
    <div className='team-info-delete' onClick={clickDelete}>Delete team</div>
  </div>
}

TeamInfo.propTypes = {
  initialName: PropTypes.string.isRequired,
  league: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default TeamInfo
